import { Component, Input, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { IdentityAuthService } from "../../_services/identity-auth.service";

@Component({
    templateUrl: './signout.component.html',
    standalone: false
})
export class SignoutComponent implements OnInit {
    constructor(private router: Router, private identityAuthService: IdentityAuthService) { }

    @Input()
    returnUrl: string = "";

    async ngOnInit() {
        await this.identityAuthService.signOut();
        if (this.returnUrl) {
            if (this.returnUrl.startsWith("http:") || this.returnUrl.startsWith("https:")) {
                window.location.href = this.returnUrl;
            } else {
                this.router.navigateByUrl(this.returnUrl);
            }
        } else {
            this.router.navigate(['/signin']);
        }
    }
}



